// extracted by mini-css-extract-plugin
module.exports = {"bannerComponent":"ka","red":"la","calloutlink":"ma","headerTopBanner":"na","bgcolorRed":"oa","headerTopCallout":"pa","searchBanner":"qa","hideMobile":"ra"};